import Image from 'next/image';
import { ProductDetailItemProps } from "./constants"
import ReactPlayer from 'react-player/youtube';
import Cookies from 'js-cookie';
import { motion } from 'framer-motion';
import { motionVariants } from '../Common/GlobalVars';


const Description = (props: ProductDetailItemProps) => {
  const viewport = Cookies.get('viewport');
  const { name, description_media_list } = props;

  return (
    <>
      {description_media_list.map((desc, index) => (
        <motion.div
          className="w-full mt-5"
          key={index}
          initial="offscreen"
          whileInView="onscreen"
          viewport={{ once: true }}
          variants={motionVariants}
        >
          {desc.type === "image" && (
            <>
              {desc.desktop_image.length > 0 && (<Image
                src={desc.desktop_image}
                alt={name + " description image"}
                width={0}
                height={0}
                quality={100}
                sizes="100vw"
                className="hidden w-full h-auto md:block"
              />)}
              {desc.mobile_image.length > 0 && (
                <Image
                  src={desc.mobile_image}
                  alt={name + " description image"}
                  width={0}
                  height={0}
                  quality={100}
                  sizes="100vw"
                  className="w-full h-auto md:hidden"
                />
              )}
            </>
          )}
          {desc.type === "image+text" && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-5 gap-x-10">
              <div className={index % 2 === 0 ? "order-1" : "order-1 md:order-2"}>
                {desc.desktop_image.length > 0 && (<Image
                  src={desc.desktop_image}
                  alt={name + " description image"}
                  width={0}
                  height={0}
                  quality={100}
                  sizes="100vw"
                  className="hidden w-full h-auto md:block"
                />)}
                {desc.mobile_image.length > 0 && (<Image
                  src={desc.mobile_image}
                  alt={name + " description image"}
                  width={0}
                  height={0}
                  quality={100}
                  sizes="100vw"
                  className="w-full h-auto md:hidden"
                />)}
              </div>
              <div className={index % 2 === 0 ? "order-2" : "order-1"}>
                <div className="">{desc.text.title}</div>
                <div className="">{desc.text.content}</div>
              </div>
            </div>
          )}
          {desc.type === "video" && (
            <>
              {desc.video_link !== undefined && desc.video_link.length > 0 && (<ReactPlayer
                url={desc.video_link}
                width="100%"
                height={viewport?.toString() === "desktop" ? 600 : 300}
              />)}
            </>
          )}
          {desc.type === "video+text" && (
            <div className="grid grid-cols-1 gap-y-5 gap-x-10 md:grid-cols-2">
              <div className={index % 2 === 0 ? "order-2 md:order-1" : "order-2"}>
                {desc.video_link !== undefined && desc.video_link.length > 0 && (<ReactPlayer
                  url={desc.video_link}
                  width="100%"
                  height={viewport?.toString() === "desktop" ? 280 : 235}
                />)}
              </div>
              <div className={index % 2 === 0 ? "order-1 md:order-2" : "order-1 md:text-right"}>
                <div className="text-sm text-[#2C3E2F] font-dmsans font-semibold">{desc.text.title}</div>
                <div className="text-base text-[#2C3E2F] font-dmsans font-normal">{desc.text.content}</div>
              </div>
            </div>
          )}
        </motion.div>
      ))}
    </>
  )
}

export default Description
